/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Funnel_Ob_Recap_Goal_VInputs */

const en_funnel_ob_recap_goal_v = /** @type {(inputs: Funnel_Ob_Recap_Goal_VInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min a day`)
};

const es_funnel_ob_recap_goal_v = /** @type {(inputs: Funnel_Ob_Recap_Goal_VInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min al día`)
};

/**
* | output |
* | --- |
* | "{minutes} min a day" |
*
* @param {Funnel_Ob_Recap_Goal_VInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_recap_goal_v = /** @type {((inputs: Funnel_Ob_Recap_Goal_VInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Recap_Goal_VInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_recap_goal_v(inputs)
	return en_funnel_ob_recap_goal_v(inputs)
});